"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.activateTab = activateTab;
exports.requestRemoveTab = requestRemoveTab;
function activateTab(tab) {
    return {
        type: "tabs/ACTIVATE_TAB",
        payload: tab
    };
}
function requestRemoveTab(tab) {
    return {
        type: "tabs/REQUEST_REMOVE_TAB",
        payload: tab
    };
}
//# sourceMappingURL=actions.js.map